import { useContext } from 'react'

import { ConsultationContext, ConsultationContextProps } from '@/contexts/consultation'
import { Consultation, CONSULTATION_STATUS, CONSULTATION_TYPE } from '@/types/consultation'

const MAX_FOLLOW_UP_QUESTIONS = 3

interface UseConsultationTypeProps {
  consultationType: ConsultationContextProps['consultationType']
  updateConsultationType: (consultationType: CONSULTATION_TYPE) => void
}

export const useConsultationType = (): UseConsultationTypeProps => {
  const { consultationType, setConsultationType } = useContext(ConsultationContext)

  const updateConsultationType = (consultationType: CONSULTATION_TYPE) => {
    setConsultationType(consultationType)
  }

  return {
    consultationType,
    updateConsultationType
  }
}
